import { createAction, props } from "@ngrx/store";
import {
  IDeleteUserSkill,
  IDeleteUserSkills,
} from "@skills-app/models/deleteUserSkill";
import IConsultantProfile, {
  IProfileUpdateResult,
} from "@skills-app/models/consultant-profile";
import ISkillNodeWithRating from "@skills-app/models/skillNodeWithRating";
import ICreateSkillRatingMapping from "@skills-app/models/createSkillRatingMapping";
import IUserCertification, {
  IUserCertificationUpsertDto,
} from "@skills-app/models/userCertification";
import ICertification from "@skills-app/models/certification";

const prefix = "[My Profile Page]";

export const loadPage = createAction(`${prefix} Load Page`);
export const unloadPage = createAction(`${prefix} Unload Page`);

export const requestUpdateUserSkill = createAction(
  `${prefix} Request Update User Skill`,
  props<{ azureId: string; skillMapping: ISkillNodeWithRating }>(),
);

export const temporaryUpdateUserSkill = createAction(
  `${prefix} Temporary Update User Skill`,
  props<{ azureId: string; skillMapping: ISkillNodeWithRating }>(),
);

export const requestDeleteUserSkill = createAction(
  `${prefix} Request Delete User Skill`,
  props<{ deleteUserSkill: IDeleteUserSkill }>(),
);

export const requestDeleteMultipleUserSkills = createAction(
  `${prefix} Request Delete Multiple User Skill`,
  props<{ deleteUserSkills: IDeleteUserSkills }>(),
);

export const removeTemporaryUserSkill = createAction(
  `${prefix} Remove Temporary User Skill`,
  props<{ skillMapping: ISkillNodeWithRating }>(),
);

export interface UpdateUserProfileActionProps {
  profile: IConsultantProfile;
  withReload: boolean;
}

export const requestUpdateUserProfile = createAction(
  `${prefix} Request Update User Profile`,
  props<UpdateUserProfileActionProps>(),
);

export const requestCurrentUserProfile = createAction(
  `${prefix} Request Current User Profile`,
);

export const requestUserProfileStatus = createAction(
  `${prefix} Request Current User Profile Status`,
  props<{ azureId: string }>(),
);

export const downloadProfile = createAction(
  `${prefix} Download Profile`,
  props<{ fileName: string; email: string; templateType: string }>(),
);

export const selectSkill = createAction(
  `${prefix} Select Skill`,
  props<{ skillId: string }>(),
);

export const toggleSelectSkill = createAction(
  `${prefix} Toggle Skill to Selection (multiselect)`,
  props<{ skillId: string }>(),
);

export const typingBegun = createAction(`${prefix} Typing Begun`);

export const getCurrentUserProfileSuccess = createAction(
  `${prefix} Get User Profile Success`,
);

export const getCurrentUserProfileStatusSuccess = createAction(
  `${prefix} Request Current User Profile Status Success`,
  props<{ profileStatus: IProfileUpdateResult }>(),
);

export const getCurrentUserProfileStatusError = createAction(
  `${prefix} Request Current User Profile Status Error`,
);

export const updateUserProfileSuccess = createAction(
  `${prefix} Update User Profile Success`,
  props<{ profileUpdateResult: IProfileUpdateResult }>(),
);

export const updateUserProfileError = createAction(
  `${prefix} Update User Profile Error`,
);

export const requestUpsertUserSkill = createAction(
  `${prefix} Request Upsert User Skill`,
  props<{ upsertedSkill: ISkillNodeWithRating }>(),
);

export const requestSaveUpsertedSkills = createAction(
  `${prefix} Save Upserted User Skills`,
  props<{ azureId: string }>(),
);

export const clearUpsertedSkills = createAction(
  `${prefix} Clear Upserted User Skills`,
);

export const requestSaveUpsertedSkillsError = createAction(
  `${prefix} Save Upserted User Skills Error`,
  props<{ unsavedSkills: ICreateSkillRatingMapping[] }>(),
);

export const requestCurrentUserCertifications = createAction(
  `${prefix} Request Current User Certifications`,
);

export const requestCurrentUserCertificationsSuccess = createAction(
  `${prefix} Request Current User Certifications Success`,
  props<{ userCertifications: IUserCertification[] }>(),
);

export const requestCurrentUserCertificationsError = createAction(
  `${prefix} Request Current User Certifications Error`,
);

export const requestSelectedUserCertifications = createAction(
  `${prefix} Request Selected User Certifications`,
  props<{ azureId: string }>(),
);

export const requestSelectedUserCertificationsSuccess = createAction(
  `${prefix} Request Selected User Certifications Success`,
  props<{ userCertifications: IUserCertification[] }>(),
);

export const requestSelectedUserCertificationsError = createAction(
  `${prefix} Request Selected User Certifications Error`,
);

export const requestUpsertUserCertifications = createAction(
  `${prefix} Request Upsert User Certifications`,
  props<{ certifications: IUserCertificationUpsertDto[]; azureId: string }>(),
);

export const requestUpsertUserCertificationsSuccess = createAction(
  `${prefix} Request Upsert User Certifications Success`,
  props<{ certifications: IUserCertification[] }>(),
);

export const requestUpsertUserCertificationsError = createAction(
  `${prefix} Request Upsert User Certifications Error`,
);

export const requestDeleteUserCertification = createAction(
  `${prefix} Request Delete User Certification`,
  props<{ userCertificationId: string; azureId: string }>(),
);

export const requestDeleteUserCertificationSuccess = createAction(
  `${prefix} Request Delete User Certification Success`,
  props<{ userCertificationId: string }>(),
);

export const requestDeleteUserCertificationError = createAction(
  `${prefix} Request Delete User Certification Error`,
);

export const requestFilterCertifications = createAction(
  `${prefix} Request Filter Certifications`,
  props<{ certNameSubString: string }>(),
);

export const requestFilterCertificationsSuccess = createAction(
  `${prefix} Request Filter Certifications Success`,
  props<{ certifications: ICertification[] }>(),
);

export const requestFilterCertificationsError = createAction(
  `${prefix} Request Filter Certifications Error`,
);

export const clearFilteredCertifications = createAction(
  `${prefix} Clear Filtered Certifications`,
);

export const reorderSkills = createAction(
  `${prefix} Reorder Skills`,
  props<{ azureId: string; skills: ISkillNodeWithRating[] }>(),
);

export const reorderSkillsSuccess = createAction(
  `${prefix} Reorder Skills Success`,
);

export const reorderSkillsError = createAction(
  `${prefix} Request Reorder Skills Error`,
);
